import { Vue } from 'vue-property-decorator'
import qs from 'qs'

export default {
  listForm: {},
  /**
     * Install the System request class.
     *
     * @param {Object} Vue The global Vue.
     * @param {Object} options Any options we want to have in our plugin.
     * @return {void}
     */

  install (Vue) {
    Vue.prototype.$axios = Vue.axios = this
    Vue.prototype.$sansys = Vue.sansys = this
    this.HTTP = Vue.prototype.$http
  },

  async post (url, payload, configs) {
    if (configs) { return await this.HTTP.post(url, payload, configs) } else { return await this.HTTP.post(url, payload) }
  },

  async get (url, payload, configs) {
    if (configs) { return await this.HTTP.get(url, payload, configs) } else { return await this.HTTP.get(url, payload) }
  },

  async put (url, payload, configs) {
    if (configs) { return await this.HTTP.put(url, payload, configs) } else { return await this.HTTP.put(url, payload) }
  },

  async delete (url, id) {
    return await this.HTTP.delete(url + '/' + id)
  },

  getFWData (nmInterface, { ...extraParams }, funcionalidade) {
    return this.post(`fw-data/dados?interface=${nmInterface}`, {

      funcionalidade,
      ...extraParams,
      method: 'montarDados'
    })
  },

  getFWForm (nmInterface, { ...extraParams }, funcionalidade) {
    if (!nmInterface) { nmInterface = extraParams.nmInterface || extraParams.interface }
    return this.post(`fw-form/resolveForm?nmInterface=${nmInterface}`, {
      funcionalidade,
      ...extraParams
    })
  },

  getFWSearch (nmInterface, extraParams) {
    return this.get('fw-data/componentePesquisaFW', {
      params: {
        ...extraParams,
        method: 'pesquisar',
        interface: nmInterface
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    })
  },

  getFWDadosCombo (nmInterface, { ...extraParams }, funcionalidade) {
    return this.get('fw-data/dados', {
      params: {
        funcionalidade,
        ...extraParams,
        method: 'getDadosCombo',
        interface: nmInterface
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    })
  },

  getFWDadosComboAtual (nmInterface, { ...extraParams }, funcionalidade) {
    return this.get('fw-data/dados', {
      params: {
        funcionalidade,
        ...extraParams,
        method: 'getDadosComboAtual',
        interface: nmInterface
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    })
  },

  getFWLogic (nmInterface, { ...extraParams }, funcionalidade) {
    const url = `fw-data/defaultAprFW?method=executar&interface=${nmInterface}`
    if (funcionalidade) url.concat(`&funcionalidade=${funcionalidade}`)
    return this.post(url, {
      ...extraParams
    })
  },

  putCrudFW (nmInterface, params) {
    return this.put('fw-data/crud' + '?' + new URLSearchParams({
      method: 'update',
      interface: nmInterface
    }).toString(), params)
  },

  postCrudFW (nmInterface, params) {
    return this.put('fw-data/crud' + '?' + new URLSearchParams({
      method: 'create',
      interface: nmInterface
    }).toString(), params)
  },

  deleteCrudFW (nmInterface, params) {
    return this.put('fw-data/crud' + '?' + new URLSearchParams({
      method: 'delete',
      interface: nmInterface
    }).toString(), params)
  },

  inactivateCrudFW (nmInterface, params) {
    return this.put('fw-data/crud' + '?' + new URLSearchParams({
      method: 'inactivate',
      interface: nmInterface
    }).toString(), params)
  },

  activateCrudFW (nmInterface, params) {
    return this.put('fw-data/crud' + '?' + new URLSearchParams({
      method: 'activate',
      interface: nmInterface
    }).toString(), params)
  },

  async pesquisar (nmInterface, extraParams) {
    return await this.getFWSearch(nmInterface, extraParams)
  },
  montarTela (nmInterface, extraParams) {
    return new Promise(async (resolve, reject) => {
      try {
        const {
          data: {
            forms: [{ ...form }]
          }
        } = await this.getFWForm(nmInterface, extraParams)
        const {
          data: { relacionamentos, dadosForm }
        } = await this.getFWData(nmInterface, extraParams)
        resolve({
          ...form,
          relacionamentos,
          dadosForm
        })
      } catch (e) {
        reject(e)
      }
    })
  },
  async manterComponente (nmInterface, extraParams) {
    if (!extraParams.nrLinhaSelecionada) {
      extraParams.nrLinhaSelecionada = 0
    }
    return await this.post('fw-data/componenteManutencaoFW', {
      interface: nmInterface,
      ...extraParams
    })
  },
  async pesquisarDadosSelecao (nmInterface, params) {
    return await this.get('fw-data/componentePesquisaFW', {
      params: {
        method: 'pesquisarDadosSelecao',
        ...params,
        interface: nmInterface
      }
    })
  }
}

export const JtechAxios = {
  request: function () {
    return Vue.prototype.$axios
  }
}
